var _mask, _mask2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFinanceStep01 = function SvgIconFinanceStep01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 120,
    width: 120,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-finance-step01_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.734.703h93.044V93H.734z",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-finance-step01_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 98.625h99.778V0H0z",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-282-156h1440v789H-282z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.776 71.319H69.142V60.218l23.563-23.563-5.91-5.91-17.653 17.652V.703H6.684v5.255H.734V93h62.945v-9.362h16.999-.001 1.565c6.212 0 11.26-4.915 11.508-11.067a.277.277 0 0 0 .028-.117v-1.135z",
    fill: "#cfdde9",
    mask: "url(#icon-finance-step01_svg__a)",
    transform: "translate(21.75 16.125)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#051a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.283 59.319-5.463 5.463m0 0-3.722 3.722-1.081 4.037-1.082 4.036 4.037-1.081 1.848-.495m5.463-3.862 23.564-23.563-5.91-5.91-17.654 17.653M79.82 75l2.188-.586 3.275-3.275M79.82 82.24H47.461v1.135c0 .042-.01.082-.027.117-.249 6.152-5.296 11.068-11.509 11.068H79.82m16.998 0h1.565c6.213 0 11.26-4.916 11.508-11.067a.272.272 0 0 0 .028-.118V82.24H85.283m11.535 12.32H79.82m0-12.32h5.463m0-11.101V82.24M79.82 94.56h16.999M85.283 59.32V11.624H22.825v5.256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.825 16.88v66.309h.009c.09 6.294 5.212 11.37 11.527 11.37h45.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.825 16.88h-5.95v87.042H79.82V94.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.694 33.954h44.194V12.048H16.694zm-.001 8.451h44.194v-4.154H16.693zm0 8.294h44.194v-4.155H16.693zm.001 8.451H44.64v-4.154H16.693z",
    mask: "url(#icon-finance-step01_svg__b)",
    transform: "translate(15.75 10.5)"
  })))));
};
export default SvgIconFinanceStep01;